export default "__VITE_ASSET__lBlTdP40__"